import { IntroSectionData } from "../../../types/IntroSectionData";
import Img0 from '../../../assets/images/itm-3.png';
import Img1 from '../../../assets/images/itm-2.png';
import Img2 from '../../../assets/images/itm-6.png';
import Img3 from '../../../assets/images/itm-4.png';
import Img4 from '../../../assets/images/itm-7.png';

const introSectionData1: IntroSectionData = {
  sectionTitle: "Expertise",
  sectionSubtitle: "Audit de cybersécurité.",
  translationNamespace: "auditCyber",
  tabsData: [
    {
      id: 0,
      title: "Méthodologie",
      heading: "Support technique réactif",
      text: "Nos auditeurs certifiés maîtrisent les méthodologies d'audit reconnues et les standards de sécurité internationaux. Nous fournissons des rapports d'audit détaillés pour comprendre vos forces et vos faiblesses.",
      key: "methodologie"
    },
    {
      id: 1,
      title: "Expertise",
      heading: "Expertise technique en sécurité des infrastructures et des applications",
      text: "Nos auditeurs sont expérimentés et possèdent une expertise technique approfondie dans la sécurisation des systèmes d'informations, des architectures cloud, des réseaux, des systèmes d'exploitation, des bases de données.",
      key: "expertise"
    },
    {
      id: 2,
      title: "Accompagnement",
      heading: "Expertise multi-cloud et technologies de pointe",
      text: "Nous vous accompagnons dans la remédiation des failles, la sensilisation de vos équipes et le suivi post-audit pour vous aider à maintenir un niveau de sécurité optimal sur le long terme.",
      key: "accompagnement"
    },
    {
    id: 3,
    title: "Conformité",
    heading: "Compréhension des enjeux de conformité et des exigences réglementaires",
    text: "Nous évaluons votre niveau de conformité par rapport aux exigences applicables à votre secteur d'activité et vous proposons des recommandations concrètes pour combler les éventuelles lacunes.",
    key: "conformite"
    },
  ],
  fixedImageSrc: Img0,
  fixedImageAlt: "IT Monkeys Cloud Cyber",
};

export default introSectionData1;